<template>
	<el-dialog :append-to-body="true" :visible="visible" width="900px" custom-class="register-dialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" center>
		<!-- 关闭按钮 -->
		<div class="dialog-close" @click="handleClose">
			<i class="el-icon-close"></i>
		</div>

		<!-- 主体内容 -->
		<div class="register-main">
			<!-- 左边：注册说明 -->
			<div class="register-left">
				<div class="register-info-box">
					<!-- <img src="@/assets/images/20260303-132952.png" alt="" class="net-logo" /> -->
					<img src="@/assets/images/logo_person_.png" alt="" class="net-logo" />
					<h3 class="section-title">注册</h3>
					<div class="register-tips">
						<p>欢迎注册特规通平台</p>
					</div>
				</div>
			</div>

			<!-- 右边：注册表单 -->
			<div class="register-right">
				<div class="register-link"><span>已有账号？</span><el-link type="primary" :underline="false" @click="switchToLogin">前往登录></el-link></div>
				<div class="form-container">
					<!-- 注册方式切换 -->
					<!-- <div class="register-type-tabs flexBetween"> -->
					<!-- <el-link type="primary" :underline="false" @click="switchToLogin">前往登录></el-link> -->
					<!-- </div> -->

					<!-- 手机注册表单 -->
					<el-form v-show="loginType === 'phone'" ref="RegisterForm" :model="formData" :rules="rules" class="register-form" label-width="0">
						<!-- 手机号输入 -->
						<el-form-item prop="phone">
							<el-input v-model.trim="formData.phone" placeholder="请输入手机号码" size="large" prefix-icon="el-icon-mobile-phone" maxlength="11" />
						</el-form-item>

						<!-- 密码输入 -->
						<el-form-item prop="password">
							<el-input v-model.trim="formData.password" type="password" placeholder="密码由4-16位字母、数字组成" size="large" prefix-icon="el-icon-lock" show-password />
						</el-form-item>

						<!-- 确认密码输入 -->
						<el-form-item prop="rePassword">
							<el-input v-model.trim="formData.rePassword" type="password" placeholder="确认密码须和密码一致" size="large" prefix-icon="el-icon-lock" show-password />
						</el-form-item>

						<!-- 验证码输入 -->
						<el-form-item prop="verifyCode">
							<div class="verify-code-input">
								<el-input v-model.trim="formData.verifyCode" placeholder="请输入短信验证码" size="large" prefix-icon="el-icon-message" maxlength="6" />
								<el-button :disabled="waitNum > 0" type="primary" size="large" @click="toSendMsg" class="send-code-btn">
									{{ waitNum > 0 ? waitNum + '秒后重发' : '获取验证码' }}
								</el-button>
							</div>
						</el-form-item>

						<!-- 邀请码（可选） -->
						<div class="recommend-divider"></div>
						<el-form-item class="recommend-code-item">
							<el-input v-model.trim="formData.recommendCode" placeholder="邀请码（选填，填写可赠送VIP会员时长）" size="large" prefix-icon="el-icon-present" />
						</el-form-item>

						<!-- 协议同意 -->
						<el-form-item class="agreement-item">
							<el-checkbox v-model="formData.agreeFlag">
								已阅读并同意
								<div class="agreement-text">
									<el-link type="primary" :underline="false" @click="goto(1, '用户协议')">用户协议</el-link>、
									<el-link style="margin-left: -2px" type="primary" :underline="false" @click="goto(2, '隐私协议')">隐私协议</el-link>、
									<el-link style="margin-left: -2px" type="primary" :underline="false" @click="goto(3, '图书销售协议')">图书销售协议</el-link>
								</div>
							</el-checkbox>
						</el-form-item>

						<!-- 注册按钮 -->
						<el-form-item>
							<el-button :loading="loadingLoginBtn" type="primary" size="large" class="register-btn" @click="handleLogin"> 立即注册 </el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import { mapActions } from 'vuex';
	import EReg from '@/utils/EReg';
	import EFormat from '@/utils/EFormat';
	import Y from '@/utils/Y';
	import Verify from '@/components/Verifition/Verify.vue';
	import TMessage from '@/utils/TMessage';
	import { getMemberSms } from '@/api/user/login';
	import mtils from 'mtils';
	import CUser from '@/utils/User';
	import { SITE_URL, LOGIN_TYPE_PERSONAL } from '@/data/siteConfig';
	import { goLoginRedirect } from '@/utils/complianceEntry';

	export default {
		name: 'RegisterBox',
		data() {
			// 手机号验证规则
			const validatePhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号码'));
				}
				if (!mtils.validation.isMobile(value)) {
					return callback(new Error('手机号码格式不正确'));
				}
				callback();
			};

			// 验证码验证规则
			const validateCode = (rule, value, callback) => {
				const patternCode = /^[0-9]{6}$/;
				if (!value) {
					return callback(new Error('请输入短信验证码'));
				}
				if (!patternCode.test(value)) {
					return callback(new Error('验证码格式不正确'));
				}
				callback();
			};

			//校验密码
			const validatePass = (rule, value, callback) => {
				const reg = /([A-Za-z]|[0-9]){4,16}/;
				if (value === '') {
					callback(new Error('密码不可为空'));
				} else if (reg.test(value) === false) {
					callback(new Error('新密码必须由 4-16位字母、数字组成'));
				} else {
					callback();
				}
			};

			//校验重复密码
			const validatePassCheck = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('确认密码不可为空'));
				} else if (value !== this.formData.password) {
					callback(new Error('两次密码不一致'));
				} else {
					callback();
				}
			};

			// 返回data
			return {
				loadingLoginBtn: false,
				loginType: 'phone',
				formData: {
					phone: '',
					password: '',
					rePassword: '',
					verifyCode: '',
					verifyKey: '',
					agreeFlag: false,
					recommendCode: ''
				},
				waitNum: 0,
				wtimer: null,
				rules: {
					phone: [{ validator: validatePhone, trigger: 'blur' }],
					verifyCode: [{ validator: validateCode, trigger: 'blur' }],
					password: [{ required: true, validator: validatePass, trigger: 'blur' }],
					rePassword: [{ required: true, validator: validatePassCheck, trigger: 'blur' }]
				},

				// 微信注册的对象
				wechat: null
			};
		},

		computed: {
			visible() {
				let val = this.$store.getters['Settings/sRegisterShow'];
				if (val) {
					this.$nextTick(() => {
						this.$refs.RegisterForm.resetFields();
					});
				} else {
					this.stopWait();
				}
				return val;
			}
		},
		watch: {
			// visible(newVal) {
			// 	if (newVal) {
			// 		this.$nextTick(() => {
			// 			this.$refs.RegisterForm.resetFields();
			// 		});
			// 	}else {
			// 		this.stopWait();
			// 	}
			// },
		},
		components: { Verify },
		methods: {
			goto(id, title) {
				let query = {
					group: '关于我们',
					id,
					type: 'content',
					title
				};
				const routeData = this.$router.resolve({
					path: '/info',
					query
				});
				window.open(routeData.href, '_blank');
			},

			//注册提交
			handleLogin() {
				this.$refs.RegisterForm.validate(valid => {
					if (valid) {
						if (!this.formData.agreeFlag) {
							TMessage.warning('请阅读并同意注册协议');
							return;
						}
						this.loadingLoginBtn = true;
						const loginParams = {
							itype: 1,
							phone: this.formData.phone,
							verifyCode: this.formData.verifyCode,
							verifyKey: this.formData.verifyKey,
							password: EFormat.base64encode(this.formData.password)
						};
						if (this.formData.recommendCode) {
							loginParams.recommendCode = this.formData.recommendCode;
						}
						console.log('注册参数：', loginParams);
						this.$store
							.dispatch('User/login', loginParams)
							.then(async () => {
								// this.onSuccess();
								TMessage.success('注册并登录成功');
								// this.close();
								// 标记登录类型为个人版
								CUser.setLoginType(LOGIN_TYPE_PERSONAL);
								// 跳转到个人版子域名（开发环境通过 URL 参数传递 token）
								await goLoginRedirect(SITE_URL.PERSON, CUser.getToken());
							})
							.catch(error => {
								TMessage.error(error.msg || '注册失败');
							})
							.finally(() => {
								this.loadingLoginBtn = false;
							});
					}
				});
			},

			// 注册成功后执行
			onSuccess() {
				this.visible = false;
				this.$emit('success');
			},

			//发送短信接口
			toSendMsg() {
				this.$refs.RegisterForm.validateField('phone', errorMessage => {
					if (!errorMessage) {
						this.startWait();
						getMemberSms(this.formData.phone).then(res => {
							let { code, data, msg } = res;
							if (code == 200) {
								this.formData.verifyKey = data;
								TMessage.success('验证码已发送');
							} else if (msg) {
								this.stopWait();
								TMessage.warning(msg);
							} else {
								this.stopWait();
								TMessage.warning('短信发送失败');
							}
						});
					}
				});
			},

			//开始倒计时
			startWait() {
				this.waitNum = 60;
				if (this.wtimer) {
					this.stopWait();
				}
				this.wtimer = setInterval(() => {
					this.waitNum--;
					// 倒计时结束
					if (this.waitNum <= 0) {
						this.stopWait();
					}
				}, 1000);
			},

			//停止倒计时
			stopWait() {
				clearInterval(this.wtimer);
				this.wtimer = null;
				this.waitNum = 0;
			},

			//打开滑块验证码
			onOpenVerify() {
				let imobile = this.formData.phone || '';

				if (this.formData.agreeFlag == false) {
					TMessage.warning('请阅读并同意注册协议！');
					return false;
				}

				if (!EReg.isSimMobile(imobile)) {
					TMessage.warning('非法的手机号码！');
					this.$refs.ifmobile.focus();
				} else {
					this.$refs.verify.show();
				}
			},

			/**
			 * 开启窗口
			 */
			open() {
				// this.visible = true;
			},

			/**
			 * 关闭窗口
			 */
			close() {
				this.setRegisterShow(false);
				// this.visible = false;
			},

			// 关闭弹窗
			handleClose() {
				this.close();
			},

			// 切换到登录
			switchToLogin() {
				this.$emit('login');
			},

			// 关闭窗口
			beforeClose(done) {
				done();
			},

			...mapActions('User', ['login']),
			...mapActions('Settings', ['setRegisterShow'])
		}
	};
</script>

<style lang="less" scoped>
	// 弹窗样式
	:deep(.register-dialog) {
		.el-dialog {
			border-radius: 12px;
			overflow: hidden;
			box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);

			.el-dialog__header {
				display: none;
			}

			.el-dialog__body {
				padding: 0;
			}
		}
	}

	.register-main {
		display: flex;
		min-height: 500px;
		background: white;
	}

	.register-left {
		flex: 1;
		padding: 20px 40px;
		background: #f5f7fa;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-top: 20px;

		.net-logo {
			position: absolute;
			left: 8px;
			top: -54px;
			width: 180px;
		}
	}

	.register-info-box {
		text-align: center;

		.section-title {
			font-size: 30px;
			color: #303133;
			margin-bottom: 30px;
			font-weight: 600;
		}

		.register-tips {
			color: #606266;
			font-size: 14px;
			line-height: 1.8;

			p {
				margin: 8px 0;
			}
		}
	}

	.register-right {
		flex: 1;
		padding: 40px;
		background: #fff;
		position: relative;
	}

	.form-container {
		max-width: 380px;
		margin: 0 auto;
		position: relative;
	}

	.dialog-close {
		position: absolute;
		top: 15px;
		right: 15px;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #f5f7fa;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.3s ease;
		z-index: 1000;

		&:hover {
			background: #e4e7ed;
			color: #409eff;
		}

		i {
			font-size: 16px;
			font-weight: 600;
		}
	}

	.register-link {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 20px;
		font-size: 14px;
		color: #94a3b8;

		span {
			line-height: 1.5;
		}
	}

	.register-type-tabs {
		flex-direction: row-reverse;
		margin-bottom: 35px;

		.type-tabs {
			display: flex;
			list-style: none;
			padding: 0;
			margin: 0;
			border-bottom: 1px solid #e4e7ed;

			li {
				padding: 12px;
				font-size: 16px;
				color: #303133;
				cursor: pointer;
				transition: all 0.3s ease;
				position: relative;
				border-bottom: 3px solid #fff;
				margin-bottom: -1px;
				font-weight: 600;

				&:hover {
					color: #409eff;
				}

				&.active {
					color: #409eff;
					border-bottom-color: #409eff;
					font-weight: 600;
				}
			}
		}
	}

	.register-form {
		.el-form-item {
			margin-bottom: 28px;

			.el-form-item__content {
				line-height: normal;
			}
		}

		.verify-code-input {
			display: flex;
			gap: 12px;

			.el-input {
				flex: 1;
			}

			.send-code-btn {
				white-space: nowrap;
				min-width: 110px;
				font-size: 14px;
			}
		}

		.agreement-item {
			margin-bottom: 25px;

			:deep(.el-checkbox__label) {
				font-size: 13px;
				color: #606266;
				line-height: 1.5;
				position: relative;
			}

			.el-link {
				font-size: 13px;
			}

			.agreement-text {
				display: inline-block;
				line-height: 1.5;
				position: absolute;
				top: -2px;
			}
		}

		.register-btn {
			width: 100%;
			height: 44px;
			font-size: 16px;
			border-radius: 6px;
			font-weight: 500;
			letter-spacing: 1px;
		}

		.recommend-code-item {
			margin-bottom: 28px;
		}

		.recommend-divider {
			height: 1px;
			background: linear-gradient(to right, transparent, #e4e7ed, transparent);
			margin-bottom: 20px;
		}
	}

	.wechat-register-box {
		text-align: center;

		.wechat-login-box {
			text-align: center;
			height: 260px;
			padding-top: 10px;
		}

		.wechat-tips {
			margin-top: 20px;
			color: #606266;
			font-size: 14px;
			line-height: 1.5;
		}
	}

	// 响应式设计
	@media (max-width: 768px) {
		.register-main {
			flex-direction: column;
			min-height: auto;
		}

		.register-left {
			border-bottom: 1px solid #e4e7ed;
			padding: 30px 20px;
		}

		.register-right {
			padding: 30px 20px;
		}

		.form-container {
			max-width: 100%;
		}
	}

	// Element UI 标准字体和颜色
	:deep(.el-input__inner) {
		border-radius: 6px;
		font-size: 14px;
	}

	:deep(.el-button) {
		border-radius: 6px;
	}
</style>
